module.exports = __webpack_public_path__ + "img/iranServer.c5f1e9f.svg";